import React, { useEffect, useState } from "react";
import { useRefreshTick } from "@/lib/autoRefresh";
import { api } from "@/lib/api";
import { formatRupiah, formatDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Coins, ChevronDown } from "lucide-react";

function BranchRow({ b, showAll }) {
  const [open, setOpen] = useState(false);
  const rows = showAll ? b.pemohon : b.pemohon.filter((r) => r.balance > 0.001);
  const key = b.branch_id || "none";
  return (
    <div className="border-t first:border-t-0" data-testid={`cash-bal-branch-${key}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 px-3 py-2.5 hover:bg-secondary/60 transition-colors text-left" data-testid={`cash-bal-branch-toggle-${key}`}>
        <div className="min-w-0">
          <p className="font-semibold text-sm truncate">{b.branch_name}</p>
          <p className="text-[11px] text-muted-foreground">{b.pemohon.filter((r) => r.balance > 0.001).length} dari {b.pemohon.length} Pemohon belum setor{b.pending > 0 ? ` · ${formatRupiah(b.pending)} menunggu konfirmasi` : ""}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className={`font-mono font-bold text-sm ${b.balance > 0 ? "text-rose-700" : "text-emerald-700"}`} data-testid={`cash-bal-branch-total-${key}`}>{formatRupiah(b.balance)}</span>
          <ChevronDown className={`h-4 w-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
        </div>
      </button>
      {open && (
        <div className="px-3 pb-3 overflow-x-auto">
          {rows.length === 0 ? <p className="text-xs text-muted-foreground py-2">Semua kas sudah disetor.</p> : (
            <table className="w-full text-xs" data-testid={`cash-bal-table-${key}`}>
              <thead className="text-muted-foreground"><tr>
                <th className="text-left py-1.5">Pemohon</th><th className="text-right py-1.5">Kas Tunai Masuk</th><th className="text-right py-1.5">Sudah Disetor</th>
                <th className="text-right py-1.5">Sisa Kas</th><th className="text-right py-1.5">Setor Terakhir</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.user_id} className="border-t" data-testid={`cash-bal-row-${r.user_id}`}>
                    <td className="py-1.5">{r.name}{r.company_name && <span className="block text-[10px] text-muted-foreground">{r.company_name}</span>}</td>
                    <td className="py-1.5 text-right font-mono">{formatRupiah(r.cash_in)}</td>
                    <td className="py-1.5 text-right font-mono">{formatRupiah(r.deposited)}</td>
                    <td className={`py-1.5 text-right font-mono font-semibold ${r.balance > 0 ? "text-rose-700" : "text-emerald-700"}`} data-testid={`cash-bal-value-${r.user_id}`}>{formatRupiah(r.balance)}</td>
                    <td className="py-1.5 text-right whitespace-nowrap">{r.last_deposit ? formatDate(r.last_deposit) : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

export function CashBalancesPanel() {
  const [d, setD] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const tick = useRefreshTick();
  useEffect(() => { api.get("/cash-balances").then((r) => setD(r.data)).catch(() => {}); }, [tick]);
  if (!d) return null;
  return (
    <Card className="p-4" data-testid="cash-balances-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div>
          <h3 className="font-semibold flex items-center gap-2" style={{ fontFamily: "Outfit" }}><Coins className="h-4 w-4 text-brand" /> Sisa Kas Tunai Pemohon</h3>
          <p className="text-xs text-muted-foreground">{d.pemohon_with_balance} Pemohon masih memegang kas · klik cabang untuk detail</p>
        </div>
        <div className="text-right">
          <p className="font-mono font-bold text-lg text-rose-700" data-testid="cash-bal-total">{formatRupiah(d.total_balance)}</p>
          <label className="text-[11px] text-muted-foreground inline-flex items-center gap-1 cursor-pointer">
            <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} data-testid="cash-bal-show-all" /> Tampilkan yang sudah lunas setor
          </label>
        </div>
      </div>
      {d.branches.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="cash-bal-empty">Belum ada Pemohon dengan Input Transaksi aktif.</p> : (
        <div className="rounded-lg border">{d.branches.map((b) => <BranchRow key={b.branch_id || "none"} b={b} showAll={showAll} />)}</div>
      )}
    </Card>
  );
}
